import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { MapWallDisplayFacade, WidgetType } from '@app/features/operating-picture/map-wall-display';
import { SwitchComponent } from '@app/modules/core/components/switch/switch.component';
import { WidgetConfigFormTemplate } from '../widget-config-form-template';

interface WidgetOption {
  name: string;
  icon: string;
  id: string;
  type: WidgetType;
  showConfigForm?: () => void;
}

@Component({
  selector: 'topo-widget-selection-form',
  imports: [TranslatePipe, ReactiveFormsModule, SwitchComponent],
  templateUrl: './widget-selection-form.component.html',
  styleUrl: './widget-selection-form.component.scss'
})
export class WidgetSelectionFormComponent extends WidgetConfigFormTemplate {
  protected state = inject(MapWallDisplayFacade);

  widgetOptions: WidgetOption[] = [
    {
      name: 'MAP-DISPLAY.TIME-CARDS',
      icon: 'icon-calendar_time',
      id: 'showTimes',
      type: WidgetType.Time,
      showConfigForm: () => this.state.showTimesWidgetConfigForm()
    },
    {
      name: 'MAP-DISPLAY.LOCATIONS-CARDS',
      icon: 'icon-pin',
      id: 'showLocations',
      type: WidgetType.Location,
      showConfigForm: () => this.state.showLocationsWidgetConfigForm()
    },
    {
      name: 'MAP-DISPLAY.STATUS-CARDS',
      icon: 'icon-small_workflow',
      id: 'showStatus',
      type: WidgetType.Status
    },
    {
      name: 'MAP-DISPLAY.MAP-LEGEND',
      icon: 'icon-small_scroll',
      id: 'showMapLegend',
      type: WidgetType.MapLegend
    },
    {
      name: 'MAP-DISPLAY.ALERTS-FEED-WIDGET.NAME',
      icon: 'icon-alert_solid',
      id: 'showAlertFeed',
      type: WidgetType.AlertFeed,
      showConfigForm: () => this.state.showAlertsFeedWidgetConfigForm()
    },
    {
      name: 'MAP-DISPLAY.IMAGE-WIDGET.NAME',
      icon: 'icon-image',
      id: 'showImageCard',
      type: WidgetType.Image,
      showConfigForm: () => this.state.showImageWidgetConfigForm()
    }
  ];
}
